// extracted by mini-css-extract-plugin
module.exports = {"carousel-wrapper":"gwg-section-pphp_carousel-wrapper__qQZtp"};